import { t as localeText } from "@/shared/lib/translate";
import { createContext, type ReactNode, useContext } from "react";

export interface ActiveSpace {
  id: string;
  name: string;
  kind: "personal" | "team";
  role?: "owner" | "admin" | "member" | "viewer";
}

const ActiveSpaceContext = createContext<ActiveSpace | null>(null);

export function ActiveSpaceProvider({
  value,
  children,
}: {
  value: ActiveSpace;
  children: ReactNode;
}) {
  return (
    <ActiveSpaceContext.Provider value={value}>
      {children}
    </ActiveSpaceContext.Provider>
  );
}

export function useActiveSpace(): ActiveSpace {
  const value = useContext(ActiveSpaceContext);
  if (!value) throw new Error(localeText("interface.useactivespace_must_be_used_inside_activespacepr_8ea82da3", { defaultValue: "useActiveSpace must be used inside ActiveSpaceProvider" }));
  return value;
}
